export enum ConcentrationActionTypes {
    LIST_REQUEST = '@@Concentration/LIST_REQUEST',
    LIST_SUCCESS = '@@Concentration/LIST_SUCCESS',
    LIST_ERROR = '@@Concentration/LIST_ERROR',
    LIST_CLEAR = '@@Concentration/LIST_CLEAR',

    SELECT = '@@Concentration/SELECT',
    SELECTED = '@@Concentration/SELECTED',
    CLEAR_SELECTED = '@@Concentration/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@Concentration/CREATE_REQUEST',
    CREATE_SUCCESS = '@@Concentration/CREATE_SUCCESS',
    CREATE_ERROR = '@@Concentration/CREATE_ERROR',
    
    // READ_REQUEST = '@@Concentration/READ_REQUEST',
    // READ_SUCCESS = '@@Concentration/READ_SUCCESS',
    // READ_ERROR = '@@Concentration/READ_ERROR',

    UPDATE_REQUEST = '@@Concentration/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@Concentration/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@Concentration/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@Concentration/DELETE_REQUEST',
    DELETE_SUCCESS = '@@Concentration/DELETE_SUCCESS',
    DELETE_ERROR = '@@Concentration/DELETE_ERROR'
}

export interface ConcentrationUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
}
